import { CommonModule } from '@angular/common';
import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { LayoutLoadingComponent } from 'src/app/shared/component/layout-loading/layout-loading.component';

import { ScoreboardListComponent } from '../../components/scoreboard-list/scoreboard-list.component';
import { StatisticsSectionsComponent } from '../../components/statistics-sections/statistics-sections.component';
import { MapSectionComponent } from '../../components/map-section/map-section.component';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { PdfStatisticsCardComponent } from '../../components/pdf-components/pdf-statistics-card/pdf-statistics-card.component';
import { PdfPageComponent } from '../../components/pdf-components/pdf-page/pdf-page.component';
import { StatisticsCardData, StatisticsFilterForm } from 'src/app/shared/interfaces';
import {
  WhiteLabelPdfGendersStatistics,
  WhiteLabelTotalSessions,
  WhiteLabelUsersCommentsWithRate,
} from 'src/app/core/data/model';
import { PdfPageTwoComponent } from '../../components/pdf-components/pdf-page/pdf-page-two/pdf-page-two.component';
import { PdfPageThreeComponent } from '../../components/pdf-components/pdf-page/pdf-page-three/pdf-page-three.component';
import { DateRangeForm } from 'src/app/shared/component/date-range/date-range.component';
import { StatisticsPDFBloc } from '../../bloc/pdf-bloc';
import { takeUntil } from 'rxjs';
import { BlocState, ReadyState } from 'src/app/shared/bloc/base-bloc';
import { DateFormatter } from 'src/app/shared/helper';
import { Constants } from 'src/app/core/common';
import { SharedConstants } from 'src/app/shared/common';

@Component({
  selector: 'app-white-label-dashboard-page',
  standalone: true,
  imports: [
    CommonModule,
    LayoutLoadingComponent,
    ScoreboardListComponent,
    StatisticsSectionsComponent,
    MapSectionComponent,
    PdfPageComponent,
    PdfPageTwoComponent,
    PdfPageThreeComponent,
  ],
  templateUrl: './white-label-dashboard-page.component.html',
  styleUrls: ['./white-label-dashboard-page.component.scss'],
})
export class WhiteLabelDashboardPageComponent extends BaseComponent implements OnInit {
  statisticsCardData: StatisticsCardData[] = [];
  chartCardsData: WhiteLabelTotalSessions;
  commentsWithRate: WhiteLabelUsersCommentsWithRate;
  filter: StatisticsFilterForm;
  statisticsGenders: WhiteLabelPdfGendersStatistics;
  @ViewChild("pdf1") pdf1 : ElementRef<any>
  @ViewChild("pdf2") pdf2 : ElementRef<any>
  @ViewChild("pdf3") pdf3 : ElementRef<any>
  constructor(injector: Injector, private pdfBloc: StatisticsPDFBloc) {
    super([], injector);
    this.pdfBloc.onState.pipe(takeUntil(this.destroy$)).subscribe((state) => this.onHandlePdfBlocState(state));
  }

  //hooks
  ngOnInit(): void {}

  // publics
  getStatisticsData(data: StatisticsCardData[]): void {
    this.statisticsCardData = data;
  }
  onGetChartCardsData(data: WhiteLabelTotalSessions): void {
    this.chartCardsData = data;
  }
  onGetStatisticsGenders(data: WhiteLabelPdfGendersStatistics): void {
    this.statisticsGenders = data;
  }
  onGetComments(data: WhiteLabelUsersCommentsWithRate): void {
    this.commentsWithRate = data;
  }
  onFilterChange(filter: StatisticsFilterForm): void {
    this.filter = filter;
  }

  // privates
  private savePDF(): void {
    // document.getElementById("pdf-container").style.display = "block";
    document.getElementById("pdf-container").style.visibility = "visible";
    document.getElementById("pdf-container").style.overflow = "unset";

    this.pdfBloc.exportPdfInProgress.next(true);
    var data = document.getElementById('htmlData');
    var data1 = document.getElementById('htmlData2');
    var data3 = document.getElementById('htmlData3');
    Promise.all([
      html2canvas(data, { useCORS: true , allowTaint : true }),
      html2canvas(data1),
      html2canvas(data3, ),
    ]).then(([value1, value2, value3]) => {
      var imgWidth = 210;
      var pageHeight = 450;
      var imgHeight = (value1.height * imgWidth) / value1.width;
      const contentDataURL = value1.toDataURL('image/png');

      let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      pdf.addPage();
      var imgHeight2 = (value2.height * imgWidth) / value2.width;
      // var heightLeft = imgHeight;
      const contentDataURL2 = value2.toDataURL('image/png');
      pdf.addImage(contentDataURL2, 'PNG', 0, position, imgWidth, imgHeight2);
      pdf.addPage();
      var imgHeight3 = (value3.height * imgWidth) / value3.width;
      // var heightLeft = imgHeight;
      const contentDataURL3 = value3.toDataURL('image/png');
      pdf.addImage(contentDataURL3, 'PNG', 0, position, imgWidth, imgHeight3);
      pdf.save(`${DateFormatter(this.injector , this.filter.date.start , SharedConstants.SHORT_DATE_FORMAT)}-report.pdf`); // Generated PDF
      // document.getElementById("pdf-container").style.display = "none";

      document.getElementById("pdf-container").style.visibility = "hidden";
    document.getElementById("pdf-container").style.maxHeight = "0px";
    document.getElementById("pdf-container").style.overflow = "hidden";
      this.pdfBloc.exportPdfInProgress.next(false);

    });
  }

  private onHandlePdfBlocState(state: BlocState): void {
    if (state instanceof ReadyState) {
      this.savePDF();
    }
  }
}
